<template>
  <div class="service-manage-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <p class="label">系统：</p>
              <el-select
                v-model.number="filter.sys"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option
                  v-for="item in system"
                  :key="item.value"
                  :label="item.labelName"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <div class="label">订单编号：</div>
              <el-input
                class="input"
                v-model="filter.oid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <div class="filter-item">
              <div class="label">用户ID：</div>
              <el-input
                class="input"
                v-model="filter.uid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <div class="filter-item">
              <div class="label">审核状态：</div>
              <el-select
                v-model="filter.status"
                size="small"
                class="select"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <div class="label">售后类型：</div>
              <el-select
                v-model="filter.afterType"
                size="small"
                class="select"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="btn-box">
              <button class="search" @click="search">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
        </div>
        <el-table
          :data="serviceList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="sys"
            align="center"
            label="系统"
          ></el-table-column>
          <el-table-column
            prop="oid"
            align="center"
            label="订单编号"
          ></el-table-column>
          <el-table-column
            prop="uid"
            align="center"
            label="用户ID"
          ></el-table-column>
          <el-table-column
            prop="nickname"
            align="center"
            label="用户昵称"
          ></el-table-column>
          <el-table-column prop="phone" align="center" label="售后商品">
            <div slot-scope="scope">
              {{ scope.row.goodsName.join(",") }}
              <span v-if="scope.row.goodsNum"
                >等{{ scope.row.goodsNum }}件商品</span
              >
            </div>
          </el-table-column>
          <el-table-column
            prop="amount"
            align="center"
            label="商品金额/元"
          ></el-table-column>
          <el-table-column prop="afterType" align="center" label="类型">
            <div slot-scope="scope">
              {{ typeMap[scope.row.afterType] }}
            </div>
          </el-table-column>
          <el-table-column prop="status" align="center" label="状态">
            <div slot-scope="scope">
              {{ statusMap[scope.row.status] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="auditUid"
            align="center"
            label="审核"
          ></el-table-column>
          <el-table-column
            prop="financialAuditUid"
            align="center"
            label="财务审核"
          ></el-table-column>
          <el-table-column prop="created" align="center" label="发起时间">
            <div slot-scope="scope">
              {{ scope.row.created | dateFormat }}
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <div
              slot-scope="scope"
              style="display: flex; justify-content: center"
            >
              <div
                style="display: flex; justify-content: center"
                v-if="scope.row.status === 3 || scope.row.status === 5"
              >
                <button
                  size="mini"
                  class="table-btn"
                  @click="updateStatus(scope.row.id, 1)"
                >
                  通过
                </button>
              </div>
              <div
                style="display: flex; justify-content: center"
                v-if="scope.row.status === 3 || scope.row.status === 5"
              >
                <button
                  size="mini"
                  class="table-btn"
                  @click="updateStatus2(scope.row.id, 1)"
                >
                  驳回
                </button>
              </div>
              <div style="display: flex; justify-content: center">
                <button
                  size="mini"
                  class="table-btn"
                  @click="toDetail(scope.row.id)"
                >
                  查看
                </button>
              </div>
              <!-- <div
                style="display: flex; justify-content: center"
                v-if="scope.row.status === 1"
              >
                <button
                  size="mini"
                  class="table-btn"
                  @click="updateStatus(scope.row.id, 0)"
                >
                  开启
                </button>
              </div> -->
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer" :key="paginationKey">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="refundShow"
      class="dialog"
      width="618px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">修改退款金额</div>
      <el-form
        ref="form"
        :model="refundForm"
        class="refund-form"
        label-width="auto"
      >
        <el-form-item label="退款金额：" prop="oid" class="form-item">
          <input
            placeholder="输入退款金额"
            class="input"
            v-model.number="refundForm.oid"
            type="number"
            size="small"
            placeholder-class="placeholder"
            onKeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="refundShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handlerefund"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      title="生成中..."
      :visible.sync="showProgressDialog"
      width="30%"
      center
    >
      <el-progress
        :percentage="progress"
        :text-inside="true"
        :stroke-width="18"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import { roleMap } from '@/config.js';
// import myUtils from '../../components/common/whatever2excel';
import dayjs from 'dayjs';
export default {
  components: {
    Header
  },
  name: 'service-manage',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '订单管理',
        secondTitle: '财务审核'
      },
      filter: {
        // 过滤条件
        oid: null,
        uid: null,
        status: null,
        afterType: 0,
        sys: 0
      },
      roleMap: roleMap,
      serviceList: [], // 用户列表
      date: [],
      currentSort: null,
      oid: null,
      phone: '',
      paginationKey: +new Date(),
      showProgressDialog: false,
      progress: 0,
      refundForm: {
        oid: null,
        role: null
      },
      refundShow: false,
      typeMap: {
        2: '仅退款',
        3: '退货退款'
      },
      statusMap: {
        // 1: '已申请',
        // 2: '已审核待退货',
        3: '已退货待确认',
        5: '已审核待退款',
        6: '已确认并退款',
        7: '拒绝'
      },
      statusList: [
        {
          name: '全部',
          value: null
        },
        // {
        //   name: '已申请',
        //   value: 1
        // },
        // {
        //   name: '已审核待退货',
        //   value: 2
        // },
        {
          name: '已退货待确认',
          value: 3
        },
        {
          name: '已审核待退款',
          value: 5
        },
        // {
        //   name: '已确认并退款',
        //   value: '6'
        // },
        // {
        //   name: '拒绝',
        //   value: '7'
        // }
      ],
      typeList: [
        {
          name: '全部',
          value: 0
        },
        {
          name: '仅退款',
          value: 2
        },
        {
          name: '退货退款',
          value: 3
        }
      ],
      systemList: [],
      system: []
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name !== 'serviceDetail') {
      sessionStorage.setItem('serviceManage2', '');
    }
    next();
  },
  mounted() {
    let data = sessionStorage.getItem('serviceManage2')
      ? JSON.parse(sessionStorage.getItem('serviceManage2'))
      : '';
    if (data) {
      this.filter = {
        ...this.filter,
        ...data.filter
      };
      this.date = data.date;
      this.currentPage = data.currentPage;
      this.paginationKey = +new Date();
      this.setSearchData();
    }
    // 获取列表
    this.getServiceList();
    this.getDictionary();
  },
  computed: {},
  methods: {
    setSearchData() {
      let serviceManage = {
        currentPage: this.currentPage,
        filter: this.filter,
        date: this.date
      };
      sessionStorage.setItem('serviceManage2', JSON.stringify(serviceManage));
    },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getServiceList();
    },
    // 获取用户列表
    getServiceList() {
      this.filter.start = this.date[0] || '';
      this.filter.end = this.date[1] || '';
      // console.log(this.filter);
      this.setSearchData();
      // return;
      this.loading++;
      this.httpPost(this.$root.getAfterSaleFinancialList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter,
        status: this.filter.status ? [this.filter.status] : [3,5],
        oid: +this.filter.oid,
        uid: +this.filter.uid,
        afterType: +this.filter.afterType,
      }).then(
        (res) => {
          this.loading--;
          let newList = res.list.map((item) => {
            let length = item.skuList.length;
            let list = item.skuList;
            if (length > 2) {
              list = item.skuList.slice(0, 2);
            }
            let goodsName = list.map((good) => {
              return good.name;
            });
            return {
              ...item,
              goodsName,
              goodsNum: length > 2 ? length - 2 : 0
            };
          });
          this.serviceList = newList;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getDictionary(){
      this.getDictionaryByName('system');
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res.list;
          let obj = {};
          res.list.forEach(item => {
            obj[item.value] = item.labelName;
          });
          this[dataName + 'Map'] = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    refundModal() {
      this.serviceDetail = {};
      this.refundForm = {
        oid: null,
        role: null,
        superior: null,
        integral: null,
        kpi: null,
        stock: false
      };
      this.$refs.form && this.$refs.form.clearValidate();
      this.refundShow = true;
    },
    // 身份授权
    handlerefund() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading++;
          this.httpPut(this.$root.openAgent, this.refundForm).then(
            (res) => {
              this.loading--;
              this.refundShow = false;
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getServiceList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    // 用户详情
    toDetail(id) {
      this.$router.push({
        name: 'serviceDetail',
        query: {
          id,
          type: 2
        }
      });
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getServiceList();
    },
    // 重置过滤
    reset() {
      this.filter = {
        oid: null,
        uid: null,
        status: null,
        afterType: 0,
        sys: 0
      };
      this.date = [];
      this.getServiceList();
    },
    updateStatus(id, status) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定当前售后订单通过退款？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPost(this.$root.agreeAfterSale2, {
          id
          // status
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getServiceList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    updateStatus2(id, status) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定当前售后订单驳回退款？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.rejectAfterSale2, {
          id
          // status
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getServiceList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.service-manage-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 10px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
      }

      // 表格按钮
      .table-btn {
        // width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 8px;
      }

      .filter-item {
        margin-right: 40px;
      }

      .select, .input {
        width: 128px;
      }

      .date-input {
        width: 225px;
      }

      .btn-box {
        margin: 0;
      }

      .table {
        margin-top: 24px !important;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();
  }

  .form {
    width: 100%;
    flex-center();
    margin: 8px 0;
  }

  .refund-form {
    padding: 16px 0 16px 120px;

    .input {
      width: 220px;
      height: 32px;
      line-height: 32px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      padding: 0 15px;
      color: gray9;

      &::placeholder {
        /* WebKit browsers */
        color: #ccc;
      }
    }

    .search-btn {
      display: inline-block;
      confirm-btn();
      width: 72px;
      height: 32px;
      line-height: 32px;
      margin: 0 12px;
    }
  }
}
</style>
